import { setProgressBarCurrentStep } from '@avalara/bat-apps-shared/client/actions/progress-bar';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Pages } from '../../../../types/offers';
import SelectConnector from '../../containers/shared/connectors/select-connector';
import { useAppDispatch } from '../../hooks/use-app-dispatch';
import { selectConnector } from '../../lib/side-effects/connectors';
import { goToNextOfferStep } from '../../lib/side-effects/offer-flow';
import { stepNames } from '../../lib/side-effects/progress-bar';
import { selectState } from '../../selectors';
import { setCurrentOfferPage } from '../../store/offer';
import { setConnectorValidationStatus } from '../../store/order';

const SelectConnectorContainer = () => {
  const dispatch = useAppDispatch();
  const state = useSelector(selectState);
  const history = useHistory();

  useEffect(() => {
    dispatch(setCurrentOfferPage(Pages.SelectConnector));
    dispatch(setProgressBarCurrentStep(stepNames.selectConnector));
  }, []);

  const onSelectConnector = () => {
    dispatch(selectConnector(state.avataxSignup.selectedConnector?.id || ''));
    dispatch(setConnectorValidationStatus(true));
    dispatch(goToNextOfferStep({ history }));
  };

  return <SelectConnector onSelectConnector={onSelectConnector} isBannerHidden={true} />;
};

export default SelectConnectorContainer;
